"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _excluded = ["children", "titles", "style", "disableClick", "className", "portalIntoClassName", "size"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Tabs = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _props$activeTab;

    var _this;

    (0, _classCallCheck2.default)(this, Tabs);
    _this = _super.call(this, props);
    _this.state = {
      activeTab: (_props$activeTab = props.activeTab) !== null && _props$activeTab !== void 0 ? _props$activeTab : 0
    };
    _this.showTabHandler = _this.showTabHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "showTabHandler",
    value: function showTabHandler(index) {
      var disableClickOnTabs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!disableClickOnTabs) {
        this.setState({
          activeTab: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _children$map;

      var _this$props = this.props,
          children = _this$props.children,
          titles = _this$props.titles,
          style = _this$props.style,
          disableClick = _this$props.disableClick,
          className = _this$props.className,
          portalIntoClassName = _this$props.portalIntoClassName,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'medium' : _this$props$size,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var activeTab = this.state.activeTab;
      return (0, _preact.h)("div", {
        className: "sections__nav ".concat(className !== null && className !== void 0 ? className : '')
      }, portalIntoClassName ? (0, _preact.h)(_preactPortal.default, {
        into: "".concat(portalIntoClassName)
      }, (0, _preact.h)("ul", {
        className: "tabs--navigation qa-profile-tooltip-tabs",
        style: style
      }, titles.map(function (title, index) {
        return (0, _preact.h)("li", {
          key: index,
          className: "tabs__item qa-tab",
          onClick: function onClick() {
            return _this2.showTabHandler(index, disableClick);
          }
        }, (0, _preact.h)("button", {
          className: "tabs__btn qa-link-tab ".concat(index === activeTab ? 'tabs__btn--active' : ''),
          type: "button"
        }, title));
      }))) : (0, _preact.h)("ul", {
        className: "tabs--navigation qa-profile-tooltip-tabs",
        style: style
      }, titles.map(function (title, index) {
        var trackProps = otherProps['data-track-type'] ? {
          'data-track-type': otherProps['data-track-type'],
          'data-element-name': "".concat(title, " tab button")
        } : {};
        return (0, _preact.h)("li", {
          key: index,
          className: "tabs__item qa-tab",
          onClick: function onClick() {
            return _this2.showTabHandler(index, disableClick);
          }
        }, (0, _preact.h)("button", (0, _extends2.default)({
          className: "tabs__btn tabs__btn-".concat(size, " qa-link-tab ").concat(index === activeTab ? 'tabs__btn--active' : ''),
          type: "button"
        }, trackProps), title));
      })), (0, _preact.h)("div", {
        className: "tabs--navigation"
      }, (_children$map = children === null || children === void 0 ? void 0 : children.map(function (child, index) {
        return (0, _preact.h)("div", {
          key: index,
          className: "tabs qa-tab-content ".concat(index === activeTab ? 'tabs--active' : '')
        }, child);
      })) !== null && _children$map !== void 0 ? _children$map : null));
    }
  }]);
  return Tabs;
}(_preact.Component);

exports.default = Tabs;